/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListAwsKmsKeysSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListAwsKmsKeysRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListAwsKmsKeysSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAwsKmsKeysSecurity$outboundSchema: z.ZodMiniType<
  ListAwsKmsKeysSecurity$Outbound,
  ListAwsKmsKeysSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listAwsKmsKeysSecurityToJSON(
  listAwsKmsKeysSecurity: ListAwsKmsKeysSecurity,
): string {
  return JSON.stringify(
    ListAwsKmsKeysSecurity$outboundSchema.parse(listAwsKmsKeysSecurity),
  );
}

/** @internal */
export type ListAwsKmsKeysRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAwsKmsKeysRequest$outboundSchema: z.ZodMiniType<
  ListAwsKmsKeysRequest$Outbound,
  ListAwsKmsKeysRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function listAwsKmsKeysRequestToJSON(
  listAwsKmsKeysRequest: ListAwsKmsKeysRequest,
): string {
  return JSON.stringify(
    ListAwsKmsKeysRequest$outboundSchema.parse(listAwsKmsKeysRequest),
  );
}
